import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import endOfMonth from 'date-fns/endOfMonth';
import startOfMonth from 'date-fns/startOfMonth';

import { BankAccountView, SortParamsArg } from 'models';
import { PurchaseInvoicesState } from './types';

import { fiscalYearsApi } from 'services/fiscal-years-api';

import getCurrentFiscalYear from 'utils/fiscal-years/getCurrentFiscalYear';
import getNearestPastFiscalYear from 'utils/fiscal-years/getNearestPastFiscalYear';

const initialState: PurchaseInvoicesState = {
  bankAccount: {
    Balance: null,
    BalanceDate: null,
    Cooperative: null,
    CooperativeIds: [],
    Description: null,
    Id: 'All',
    IsMain: null,
    LogicalName: null,
    Number: 'Kaikki pankkitilit',
    ModifiedOn: '',
    Operator: null,
  },
  endDate: null,
  sortParams: {
    order: 'desc',
    orderBy: 'AccountingDate',
    type: 'date',
  },
  startDate: null,
};

export const purchaseInvoicesSlice = createSlice({
  name: 'purchaseInvoices',
  initialState,
  reducers: {
    setBankAccount: (state, action: PayloadAction<BankAccountView>) => {
      state.bankAccount = action.payload;
    },
    setStartDate: (state, action: PayloadAction<number | null>) => {
      state.startDate = action.payload;
    },
    setEndDate: (state, action: PayloadAction<number | null>) => {
      state.endDate = action.payload;
    },
    setSortParams: (state, action: PayloadAction<SortParamsArg>) => {
      const { id, type } = action.payload;

      state.sortParams = {
        order: state.sortParams.order === 'asc' ? 'desc' : 'asc',
        orderBy: id,
        type: type,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      fiscalYearsApi.endpoints.getFiscalYears.matchFulfilled,
      (state, { payload }) => {
        const currentFiscalYear = getCurrentFiscalYear(payload.FiscalYears);

        if (currentFiscalYear) {
          state.startDate = new Date(currentFiscalYear.StartDate).getTime();
          state.endDate = endOfMonth(new Date()).getTime();
        } else {
          const nearestPastFiscalYear = getNearestPastFiscalYear(
            payload.FiscalYears
          );

          if (nearestPastFiscalYear) {
            state.startDate = new Date(
              nearestPastFiscalYear.StartDate
            ).getTime();
            state.endDate = new Date(nearestPastFiscalYear.EndDate).getTime();
          } else {
            state.startDate = startOfMonth(new Date()).getTime();
            state.endDate = endOfMonth(new Date()).getTime();
          }
        }
      }
    );
  },
});

export const { setBankAccount, setEndDate, setStartDate } =
  purchaseInvoicesSlice.actions;
export default purchaseInvoicesSlice.reducer;
